import { StorageReference } from '@angular/fire/storage';

export class DownloadFolderAction {
  public static readonly type = '[Project/Storage/List] DownloadFolderAction';
  constructor(public readonly folder: StorageReference) {}
}
